export default __webpack_public_path__ + "static/media/ep4-sunrise-bg.101abe51.jpg";